
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-philosophy",
      function () {
        return require("private-next-pages/iit-philosophy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-philosophy"])
      });
    }
  